import { IconSvgProps, IconSvg } from './IconSvg';

export type IconProps = IconSvgProps;

export const Icon = ({ name, onClick }: IconProps) => <IconSvg name={name} onClick={onClick} />;
